"use strict";
export default {
  state: function(invoice) {
    if (invoice.state === "draft") {
      return "received";
    } else if (invoice.state === "abandoned") {
      return "ignored";
    } else if (invoice.state === "partial_approved") {
      return "paid but unbilled";
    }
    return invoice.state;
  },
  isFactorAccount: function(account) {
    return account.hasRole("Factor");
  }
};
